"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterPriceOptionModeState = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var SfilterPriceOption_init_1 = require("@/pages/common/states/sfilter/sections/price/SfilterPriceOption.init");
var SfilterPriceCustomOption_init_1 = require("@/pages/common/states/sfilter/sections/price/SfilterPriceCustomOption.init");
exports.defaultSfilterPriceOptionModeState = [
    {
        mode: SfilterTypeGroup_1.SfilterType.RENT,
        customOpened: false,
        selected: -1,
        options: (_a = {},
            _a[SfilterPriceGroup_1.SfilterCurrency.HKD] = SfilterPriceOption_init_1.defaultSfilterPriceOptionsRentHkd,
            _a[SfilterPriceGroup_1.SfilterCurrency.USD] = SfilterPriceOption_init_1.defaultSfilterPriceOptionsRentUsd,
            _a),
        customOptions: (_b = {},
            _b[SfilterPriceGroup_1.SfilterCurrency.HKD] = SfilterPriceCustomOption_init_1.defaultSfilterPriceCustomOptionRentHkd,
            _b[SfilterPriceGroup_1.SfilterCurrency.USD] = SfilterPriceCustomOption_init_1.defaultSfilterPriceCustomOptionRentUsd,
            _b),
    },
    {
        mode: SfilterTypeGroup_1.SfilterType.BUY,
        customOpened: false,
        selected: -1,
        options: (_c = {},
            _c[SfilterPriceGroup_1.SfilterCurrency.HKD] = SfilterPriceOption_init_1.defaultSfilterPriceOptionsBuyHkd,
            _c[SfilterPriceGroup_1.SfilterCurrency.USD] = SfilterPriceOption_init_1.defaultSfilterPriceOptionsBuyUsd,
            _c),
        customOptions: (_d = {},
            _d[SfilterPriceGroup_1.SfilterCurrency.HKD] = SfilterPriceCustomOption_init_1.defaultSfilterPriceCustomOptionBuyHkd,
            _d[SfilterPriceGroup_1.SfilterCurrency.USD] = SfilterPriceCustomOption_init_1.defaultSfilterPriceCustomOptionBuyUsd,
            _d),
    },
];
